import { Stack, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, HoldsIcon, WarningIcon, YardIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

interface Props {
  hasHold?: boolean
  hasMissingReservation?: boolean
  cannotBeFulfilled?: boolean
  allOrdersAreGeneralCargo?: boolean
}
export const OrderWarnings = observer(
  ({ hasHold, hasMissingReservation, cannotBeFulfilled, allOrdersAreGeneralCargo }: Props) => {
    const { t } = useTranslate()

    return (
      <Stack flexDirection='row' gap={1} alignItems='center'>
        {hasHold && (
          <ColoredLabel
            color='warning'
            startIcon={
              <Tooltip title={t('hasActiveHold', 'Has active hold')}>
                <HoldsIcon />
              </Tooltip>
            }
          />
        )}
        {hasMissingReservation && !allOrdersAreGeneralCargo && (
          <ColoredLabel
            color='warning'
            startIcon={
              <Tooltip title={t('noAllocationRuleMatches', 'No allocation rule matches')}>
                <YardIcon />
              </Tooltip>
            }
          />
        )}
        {cannotBeFulfilled && (
          <ColoredLabel
            color='warning'
            startIcon={
              <Tooltip title={t('orderCannotBeFulfilled', 'Order cannot be fulfilled')}>
                <WarningIcon />
              </Tooltip>
            }
          />
        )}
      </Stack>
    )
  },
)
